// src/services/api/welcomeCampaignService.js
import axios from "axios";
import API_BASE_URL from "../../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/welcome-campaign-summary`;

export const getWelcomeCampaignSummary = async (page = 1, pageSize = 50) => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        page,
        pageSize
      }
    });

    return response.data; // Será un WelcomeCampaignPatientResultDto
  } catch (error) {
    console.error("Error fetching welcome campaign summary:", error);
    throw error;
  }
};
